import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const timetableSessions = [
    { name: "सेमेस्टर 1", downloadLink: "#" },
    { name: "सेमेस्टर 2", downloadLink: "#" },
    { name: "गर्मी का सत्र", downloadLink: "#" },
];

const TimetableTable = () => {
    return (
        <div className="container mt-4">
            <h2 className="text-center mb-4">समय सारिणी</h2>
            <table className="table table-striped table-bordered">
                <thead className="thead-dark">
                    <tr>
                        <th>सत्र का नाम</th>
                        <th>डाउनलोड</th>
                    </tr>
                </thead>
                <tbody>
                    {timetableSessions.map((session, index) => (
                        <tr key={index}>
                            <td>{session.name}</td>
                            <td>
                                <a href={session.downloadLink} className="btn btn-primary btn-sm">
                                    डाउनलोड करें
                                </a>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default TimetableTable;
